import initialState from './initialState';
import produce from 'immer';
import { store } from '../../index';

export default (state = initialState.hand, action) => {
	//
	switch (action.type) {
		case 'RESET_WHOLE_STATE':
			return initialState.hand;
		//
		//

		case 'SET_CURRENT_PLAYER':

			return {
				...state,
				currentPlayer: action.currentPlayerIndex,
			};

		case 'THROW_CARD':
			return produce(state, (draft) => {
				console.log(action);
				if (action.position === 'bottom') {
					// draft.cards.splice(
					// 	draft.cards.findIndex((card) => {
					// 		return card.suit === action.suit && card.card === action.card;
					// 	}),
					// 	1
					// );

					draft.chosenCard = {
						show: action.show,
						suit: action.suit,
						card: action.card,
					};
				}
				// send play to back end
			});

		case 'ENABLE_HAND':
		case 'DISABLE_HAND':
			return produce(state, (draft) => {
				console.log(draft);
				draft.handActive = action.value;
			});

		case 'RESET_HAND':
			return produce(state, (draft) => {
				// draft.cards = [];
				draft.chosenCard.show = false;
			});

		case 'SET_CARDS':
			console.log(action);
			return produce(state, (draft) => {
				// if (action.extend) {
				// 	// draft.cards = [...draft.cards, convertCards(action.cards)];
				// 	const cardsToAdd = convertCards(action.cards);
				// 	cardsToAdd.forEach((card) => {
				// 		draft.cards.push(card);
				// 	});
				// } else {
				draft.cards = convertCards(action.cards);
				// draft.cards = [];

				// }
			});

		case 'SHOW_CLOCK':
			return produce(state, (draft) => {
				if (action.position === 'bottom' || action.value === false) {
					draft.clock = action.value;
				}
			});

		// case 'SET_CARDS_FIRST':
		// 	return produce(state, (draft) => {
		// 		draft.cards = [];
		// 	});
		// 	store.dispatch({ type: 'SET_CARDS', action });

		default:
			return state;
	}
};

const convertCards = (cards) => {
	console.log(cards);
	let cardsOutput = [];
	cards.forEach((card) => {
		let cardOut = convertCard(card);
		//
		cardsOutput.push(cardOut);
	});
	console.log(cardsOutput);

	return cardsOutput;
};

// export const convertCard = (card) => {
// 	let cardOut = {};
// 	cardOut.card = card.fValue;
// 	cardOut.suit = card.fSuite;

// 	return cardOut;
// };

export const convertCard = (card) => {
	// convert card
	const type = {
		0: 'heart', // ,
		1: 'nut', // ,
		2: 'leave', // ,
		3: 'bell', // ,
	};
	const value = {
		2: 'jack', // ,
		3: 'queen', // ,
		4: 'king', // ,
		6: 'septar', // ,
		8: 'optar', // ,
		9: 'nine', // ,
		10: 'ten', // ,
		11: 'ace', // ,
	};
	return {
		suit: card.fSuite,
		card: card.fValue
       , disabled: card.disabled
        ,
	};
};
